import { Sparkles } from 'lucide-react';

import { cn } from '@/helpers/shadcn';

/** The assistant's mark, beside each of its turns and on the welcome. */
const Avatar = ({ size = 'default' }) => {
  return (
    <div
      className={cn(
        'bg-primary/10 text-primary ring-primary/15 flex shrink-0 items-center justify-center rounded-full ring-1',
        size === 'lg' ? 'size-11 [&_svg]:size-5' : 'size-7 [&_svg]:size-3.5'
      )}
      aria-hidden="true"
    >
      <Sparkles />
    </div>
  );
};

export default Avatar;
